export enum VentureContactTypeModalMode {
  VIEW = "view",
  CREATE = "create",
  EDIT = "edit",
}
